module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app/redirect/redirect.component.html
// module id = ./src/components/app/redirect/redirect.component.html
// module chunks = main